export default "__VITE_ASSET__1534141e__"